import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Header
    home: 'Home',
    services: 'Services',
    about: 'About',
    contact: 'Contact',
    shop: 'Shop',
    callNow: 'Call Now',
    
    // Hero
    heroTitle: 'Professional Cleaning Services in',
    heroLocation: 'Peterborough',
    heroDescription: 'Reliable, insured, and DBS-checked home cleaning services. Let\'s make your home shine!',
    getFreeQuote: 'Get Free Quote',
    
    // Trust Badges
    fullyInsured: 'Fully Insured',
    fullyInsuredDesc: 'Complete insurance coverage',
    dbsChecked: 'DBS Checked',
    dbsCheckedDesc: 'All staff verified',
    ecoFriendly: 'Eco-Friendly',
    ecoFriendlyDesc: 'Safe cleaning products',
    professionalTeam: 'Professional Team',
    professionalTeamDesc: 'Experienced cleaners',
    
    // About
    aboutTitle: 'About Clean Home Peterborough',
    aboutText1: 'Clean Home Peterborough is a team of experienced, trustworthy cleaners who care about making your home spotless. We are fully insured, DBS-checked, and use eco-friendly cleaning products to ensure the safety of your family and pets.',
    aboutText2: 'With years of experience serving Peterborough and surrounding areas, we pride ourselves on delivering exceptional cleaning services that exceed expectations. Your satisfaction is our priority.',
    
    // Services
    servicesTitle: 'Our Services',
    servicesSubtitle: 'Comprehensive cleaning solutions for every need',
    andMuchMore: '...and much more!',
    
    // Testimonials
    testimonialsTitle: 'What Our Clients Say',
    testimonialsSubtitle: 'Don\'t just take our word for it',
    
    // FAQ
    faqTitle: 'Frequently Asked Questions',
    faqSubtitle: 'Everything you need to know',
    
    // Contact Form
    contactTitle: 'Get in Touch',
    contactSubtitle: 'Request a free quote or ask us anything',
    requestQuote: 'Request a Quote',
    formDescription: 'Fill out the form and we\'ll get back to you soon',
    yourName: 'Your Name',
    emailAddress: 'Email Address',
    phoneNumber: 'Phone Number',
    propertyAddress: 'Property Address',
    howManyBedrooms: 'How many bedrooms?',
    howManyBathrooms: 'How many bathrooms?',
    cleaningTypeLabel: 'What kind of cleaning is required?',
    kitchenAppliances: 'Kitchen Appliances (optional):',
    additionalDetails: 'Additional details or questions...',
    attachPictures: 'Attach Pictures (optional):',
    imagesSelected: 'image(s) selected',
    sendRequest: 'Send Request',
    
    // Contact Info
    contactInfo: 'Contact Information',
    phone: 'Phone',
    email: 'Email',
    whatsapp: 'WhatsApp',
    messageUs: 'Message us on WhatsApp',
    location: 'Location',
    followInstagram: 'Follow us on Instagram',
    
    // Footer
    quickLinks: 'Quick Links',
    ourServices: 'Our Services',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    allRightsReserved: 'All rights reserved',
    
    // Quotes Page
    quoteRequests: 'Quote Requests',
    totalRequests: 'Total requests',
    noQuotes: 'No quote requests yet',
    propertyDetails: 'Property Details',
    cleaningType: 'Cleaning Type',
    additionalMessage: 'Additional Message',
    reference: 'Reference',
    
    // Status
    new: 'NEW',
    contacted: 'CONTACTED',
    completed: 'COMPLETED',
    
    // Chatbot
    chatWithUs: 'Chat with us',
    typeMessage: 'Type your message...',
    weReplyInstantly: 'We reply instantly',
    
    // Toast messages
    quoteSuccess: 'Quote request sent successfully!',
    quoteFailed: 'Failed to submit quote. Please try again or contact us directly.',
    chatbotWelcome: 'Hi! I\'m Clean Home Assistant 👋 How can we help you today?',
  },
  
  lt: {
    // Header
    home: 'Pradžia',
    services: 'Paslaugos',
    about: 'Apie mus',
    contact: 'Kontaktai',
    shop: 'Parduotuvė',
    callNow: 'Skambinti',
    
    // Hero
    heroTitle: 'Profesionalios valymo paslaugos',
    heroLocation: 'Peterborough',
    heroDescription: 'Patikimos, apdraustos ir DBS patikrintos namų valymo paslaugos. Padarykime jūsų namus švarius!',
    getFreeQuote: 'Gauti kainų pasiūlymą',
    
    // Trust Badges
    fullyInsured: 'Pilnai apdraustas',
    fullyInsuredDesc: 'Pilna draudimo apsauga',
    dbsChecked: 'DBS patikrintas',
    dbsCheckedDesc: 'Visi darbuotojai patikrinti',
    ecoFriendly: 'Ekologiškas',
    ecoFriendlyDesc: 'Saugūs valymo produktai',
    professionalTeam: 'Profesionali komanda',
    professionalTeamDesc: 'Patyrę valytоjai',
    
    // About
    aboutTitle: 'Apie Clean Home Peterborough',
    aboutText1: 'Clean Home Peterborough - tai patyrusi, patikima valytojų komanda, kuriai rūpi padaryti jūsų namus nepriekaištingus. Esame pilnai apdrausti, DBS patikrinti ir naudojame ekologiškus valymo produktus, kad užtikrintume jūsų šeimos ir augintinių saugumą.',
    aboutText2: 'Turime daugelio metų patirtį aptarnaujant Peterborough ir aplinkinius rajonus. Didžiuojamės teikdami išskirtines valymo paslaugas, viršijančias lūkesčius. Jūsų pasitenkinimas - mūsų prioritetas.',
    
    // Services
    servicesTitle: 'Mūsų paslaugos',
    servicesSubtitle: 'Išsamūs valymo sprendimai kiekvienam poreikiui',
    andMuchMore: '...ir dar daugiau!',
    
    // Testimonials
    testimonialsTitle: 'Ką sako mūsų klientai',
    testimonialsSubtitle: 'Neimkite tik mūsų žodžio',
    
    // FAQ
    faqTitle: 'Dažniausiai užduodami klausimai',
    faqSubtitle: 'Visa, ką reikia žinoti',
    
    // Contact Form
    contactTitle: 'Susisiekite',
    contactSubtitle: 'Prašykite nemokamo pasiūlymo arba užduokite klausimų',
    requestQuote: 'Užsakyti pasiūlymą',
    formDescription: 'Užpildykite formą ir mes greitai susisieksime',
    yourName: 'Jūsų vardas',
    emailAddress: 'El. pašto adresas',
    phoneNumber: 'Telefono numeris',
    propertyAddress: 'Namo adresas',
    howManyBedrooms: 'Kiek miegamųjų?',
    howManyBathrooms: 'Kiek vonios kambarių?',
    cleaningTypeLabel: 'Kokio valymo reikia?',
    kitchenAppliances: 'Virtuvės prietaisai (neprivaloma):',
    additionalDetails: 'Papildoma informacija ar klausimai...',
    attachPictures: 'Pridėti nuotraukas (neprivaloma):',
    imagesSelected: 'nuotrauka(-os) pasirinkta',
    sendRequest: 'Siųsti užklausą',
    
    // Contact Info
    contactInfo: 'Kontaktinė informacija',
    phone: 'Telefonas',
    email: 'El. paštas',
    whatsapp: 'WhatsApp',
    messageUs: 'Rašykite mums WhatsApp',
    location: 'Vieta',
    followInstagram: 'Sekite mus Instagram',
    
    // Footer
    quickLinks: 'Greitos nuorodos',
    ourServices: 'Mūsų paslaugos',
    aboutUs: 'Apie mus',
    contactUs: 'Kontaktai',
    allRightsReserved: 'Visos teisės saugomos',
    
    // Quotes Page
    quoteRequests: 'Užsakymų užklausos',
    totalRequests: 'Viso užklausų',
    noQuotes: 'Užsakymų dar nėra',
    propertyDetails: 'Namo detalės',
    cleaningType: 'Valymo tipas',
    additionalMessage: 'Papildoma žinutė',
    reference: 'Nuoroda',
    
    // Status
    new: 'NAUJAS',
    contacted: 'SUSISIEKTA',
    completed: 'BAIGTA',
    
    // Chatbot
    chatWithUs: 'Pokalbis su mumis',
    typeMessage: 'Rašykite žinutę...',
    weReplyInstantly: 'Atsakome iš karto',
    
    // Toast messages
    quoteSuccess: 'Užklausa sėkmingai išsiųsta!',
    quoteFailed: 'Nepavyko išsiųsti užklausos. Bandykite dar kartą arba susisiekite tiesiogiai.',
    chatbotWelcome: 'Sveiki! Aš Clean Home asistentas 👋 Kaip galime padėti?',
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  
  const t = (key) => {
    return translations[language][key] || key;
  };
  
  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };
  
  // Load language from localStorage on mount
  React.useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && (savedLang === 'en' || savedLang === 'lt')) {
      setLanguage(savedLang);
    }
  }, []);
  
  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
